// ============================================================================
// CANCUN100 — leyendasPrecio.js  (Bloque 09 v2: textos que acompañan al precio en el PDF)
// ----------------------------------------------------------------------------
// LEYENDAS_PRECIO concentra en un solo lugar los textos es/en/pt de:
//   a) banda "PROMOCIÓN {MES}" (mes actual en hora de Cancún, automático),
//   b) "Precio por persona",
//   c) leyenda de apartado ($299 MXN / US$19.99, 24 h).
// Cambiar aquí y se refleja en Premium y Básico.
// ============================================================================

const MESES = {
  es: ['ENERO', 'FEBRERO', 'MARZO', 'ABRIL', 'MAYO', 'JUNIO', 'JULIO', 'AGOSTO', 'SEPTIEMBRE', 'OCTUBRE', 'NOVIEMBRE', 'DICIEMBRE'],
  en: ['JANUARY', 'FEBRUARY', 'MARCH', 'APRIL', 'MAY', 'JUNE', 'JULY', 'AUGUST', 'SEPTEMBER', 'OCTOBER', 'NOVEMBER', 'DECEMBER'],
  pt: ['JANEIRO', 'FEVEREIRO', 'MARÇO', 'ABRIL', 'MAIO', 'JUNHO', 'JULHO', 'AGOSTO', 'SETEMBRO', 'OUTUBRO', 'NOVEMBRO', 'DEZEMBRO'],
};

export const LEYENDAS_PRECIO = {
  es: {
    promo: (mes) => `PROMOCIÓN ${mes}`,
    porPersona: 'Precio por persona',
    apartado: (monto) => `Aparta con ${monto} y asegura este precio reservando dentro de las próximas 24 horas.`,
  },
  en: {
    promo: (mes) => `${mes} PROMOTION`,
    porPersona: 'Price per person',
    apartado: (monto) => `Hold it with ${monto} and lock in this price by booking within the next 24 hours.`,
  },
  pt: {
    promo: (mes) => `PROMOÇÃO ${mes}`,
    porPersona: 'Preço por pessoa',
    apartado: (monto) => `Reserve com ${monto} e garanta este preço fazendo a reserva nas próximas 24 horas.`,
  },
};

export const APARTADO_MONTO = { MXN: '$299 MXN', USD: 'US$19.99' };

// Mes actual en hora de Cancún (0..11).
export const mesCancun = (fecha = new Date()) => {
  const n = Number(new Intl.DateTimeFormat('en-US', { timeZone: 'America/Cancun', month: 'numeric' }).format(fecha));
  return (n >= 1 && n <= 12 ? n : fecha.getMonth() + 1) - 1;
};

// Textos ya resueltos para el idioma/moneda según los toggles { promo, porPersona, apartado }.
export const leyendasPara = (idioma, moneda, flags = {}, fecha = new Date()) => {
  const L = LEYENDAS_PRECIO[idioma] || LEYENDAS_PRECIO.es;
  const meses = MESES[idioma] || MESES.es;
  return {
    promo: flags.promo ? L.promo(meses[mesCancun(fecha)]) : null,
    porPersona: flags.porPersona ? L.porPersona : null,
    apartado: flags.apartado ? L.apartado(APARTADO_MONTO[moneda === 'USD' ? 'USD' : 'MXN']) : null,
  };
};
